import React from "react";
import { Container } from "react-bootstrap";
import shipping from "../../../../Asset/hero-shipping-automation-first.svg";

const Second = () => {
  return (
    <>
      <section
        className="side-image-box-section"
        style={{ backgroundColor: "var(--white-color)" }}
      >
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 order-2 order-md-2">
              <div className="info-content">
                <div className="title-paragraph">
                  What is Industrial Automation?
                </div>
                <p>
                  Industrial automation is the use of robotics and computer
                  software to enable autonomous systems to control equipment and
                  procedures used in a variety of industries.
                </p>
                <p>
                  The use of industrial automation technology by organizations
                  improves safety, frees up time, improves production quality,
                  minimizes monitoring, and lowers costs.
                </p>
                <p>
                  All of these advantages help businesses operate more
                  profitably, productively, and efficiently.
                </p>
                <ul className="check-list count_2 pt-4">
                  <li>Shipping Automation</li>
                  <li>Payment Automation</li>
                  <li>Parcel Automation</li>
                </ul>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 order-1 order-md-1">
              <div className="info-img">
                <img alt="infoImage" src={shipping} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Second;
